import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import './Booking.scss';
import BookingPhase from '../../components/BookingPhase';
import LoginComponent from './LoginComponent';

const LoginFormSelector = (props) => {
  const { loginPolicyType, t } = props;
  return (
    <BookingPhase id="booking-phase-identify-late" title={t('lateLoginPhaseTitle')}>
      <div className="center-block late-login-content">
        <div className="box-header late-login-heading">
          <h1>{t('lateLoginPhaseHeading')}</h1>
        </div>
        <LoginComponent loginType={loginPolicyType} />
      </div>
    </BookingPhase>
  );
};

LoginFormSelector.propTypes = {
  loginPolicyType: PropTypes.string.isRequired,
  t: PropTypes.object.isRequired
};

export default translate(props => ['booking', props.pathNamespace], { wait: true })(LoginFormSelector);



// WEBPACK FOOTER //
// ./src/containers/Booking/LoginFormSelector.jsx